export default __webpack_public_path__ + "static/shape-2-bc87e337deb3f6e288ae07071bf616bb.svg";